export const engages = [
  {
    key: 'souverainete',
    title: 'Souveraineté',
    text: 'Vos assistants IA et vos données restent hébergés en France, dans des infrastructures françaises et européennes.',
    iconFamily: 'fa-solid',
    icon: 'crown',
  },
  {
    key: 'securite',
    title: 'Sécurité',
    text: 'Chiffrement, cloisonnement, contrôle des accès : votre IA est administrée 24h/24 et 7j/7 par nos experts.',
    iconFamily: 'fa-solid',
    icon: 'shield-halved',
  },
  {
    key: 'confidentialite',
    title: 'Confidentialité',
    text: 'Aucune réutilisation de vos données : ni entraînement, ni analyse, ni journalisation intrusive.',
    iconFamily: 'fa-regular',
    icon: 'eye-slash',
  },
  {
    key: 'ia-souveraine',
    title: 'IA maîtrisée',
    text: 'Des modèles puissants, un catalogue évolutif et des usages cadrés : l’IA travaille pour vous, jamais contre vous.',
    iconFamily: 'fa-solid',
    icon: 'brain',
  },
  {
    key: 'supervision',
    title: 'Supervision',
    text: 'Disponibilité et performance surveillées en continu, alertes et interventions humaines à toute heure.',
    iconFamily: 'fa-regular',
    icon: 'eye',
  },
  {
    key: 'accompagnement',
    title: 'Accompagnement',
    text: 'Formation, adoption, cas d’usage : nos experts font monter vos équipes en compétence, à leur rythme.',
    iconFamily: 'fa-solid',
    icon: 'users-gear',
  },
]
